import { createContext } from "react";
import { CustomerConnection } from "../../models/websiteVistitors";

export interface StarConversationCommand {
  customerClientId: string;
  agentData: {
    agentId: string;
    agentName: string;
  };
}

export interface WebsiteVisitorsContextValue {
  customerConnections: CustomerConnection[];
  startConversation(cmd: StarConversationCommand): void;
}

export const WebsiteVisitorsContext = createContext<WebsiteVisitorsContextValue>({ customerConnections: [], startConversation: () => { } });
